"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    getId: function() {
        return getId;
    }
});
const _uniqid = /*#__PURE__*/ _interop_require_default(require("uniqid"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getId(value = undefined) {
    return value === undefined ? (0, _uniqid.default)() : value;
}
const _default = getId;
